import { render, staticRenderFns } from "./RegionalDivision.vue?vue&type=template&id=730f7472&scoped=true&"
import script from "./RegionalDivision.vue?vue&type=script&lang=js&"
export * from "./RegionalDivision.vue?vue&type=script&lang=js&"
import style0 from "./RegionalDivision.vue?vue&type=style&index=0&id=730f7472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730f7472",
  null
  
)

export default component.exports